import loadable from '@loadable/component';

const ProductTabPropertiesExperiment = loadable(() =>
  import(
    /* webpackChunkName: "ProductTabProperties" */ './product-tab-properties'
  )
);

export default ProductTabPropertiesExperiment;
